import { styled } from '@mui/material'
import React, { useState } from 'react'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { NextButton } from '../common/CommonStyled'
import { useAdLoginStore } from 'src/stores/AdLoginStore'
import { postFindId } from 'src/api/User'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PageWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection: 'column',
    gap:'50px',

    position:'absolute',
    zIndex:1,
    width:'100%',
    height:'calc(100% - 90px)',
    top:0
}))

const HeaderWrapper = styled('span')(({theme})=>({
    fontWeight:'bold',
    fontSize:'38px',
    color:'white'
}))

const LoginForm = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    gap:'10px',

    backgroundColor:'white',
    padding:'32px',
    boxShadow: '3px 5px 15px 0px rgba(0, 0, 0, 0.15)',
    borderRadius:'5px',
    // width:'100%',
    minWidth:'420px'
}))

const TextBox = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',

    padding:'28px',
    fontSize: '14px',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#F5F5F5',
    fontFamily: 'Pretendard',
    whiteSpace: 'nowrap',
    color:'#727272'
}))

const FindPasswordButton = styled('button')(({ theme }) => ({
    backgroundColor: '#FFFFFF',
    color: 'black',
    width: '100%',
    border: '1px solid #DDDDDD',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '16px',
    fontFamily: 'Pretendard',
  }));
  
  // 버튼 감싸는 컨테이너
  const ButtonContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '16px',
    width: '100%',
    flexDirection: 'column',
  }));

type miniTap = 'FindingId' | 'Correct' | 'InCorrect'

const AdFindIdBox = () => {
    const [userName, setUserName] = useState("")
    const [userPhone, setUserPhone] = useState("")
    const [userId,setUserId] = useState('')
    const [currentPage,setCurrentPage] = useState<miniTap>('FindingId')
    const [signDate, setSignDate] = useState('')
    const [errorText,setErrorText] = useState('')
    const formattedDate = signDate.slice(0, 10).replace(/-/g, ".");
    const setField = useAdLoginStore((state)=>state.setField)

    const handleSubmit = async(name:string,phone:string)=>{
        const response = await postFindId(name,phone)
    
        if(response.status === "OK"){
            setUserId(response.data.user_id)
            setSignDate(response.data.created_at)
            setCurrentPage('Correct');
        }
        else{
            if (response.status === '403'){
            setErrorText('* 관리자 승인이 필요한 계정입니다.')
            }
            else if (response.status === '423'){
            setErrorText('* 잠긴 계정입니다.')
            }
            else { 
            setErrorText('* 입력하신 정보와 일치하는 아이디가 없습니다.')
            }
            setCurrentPage('InCorrect')
        }
    }
    const onChangeName = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setUserName(e.target.value)
    }
    const onChangePhone = (e:React.ChangeEvent<HTMLInputElement>)=>{
        setUserPhone(e.target.value)
    }
  return (
    <PageWrapper>
        <HeaderWrapper>아이디 찾기</HeaderWrapper>
        <LoginForm>
            {currentPage === 'FindingId' && 
            <>
            <span style={{textAlign:'left', width:'100%'}}>이름</span>
            <InputBoxOnChange placeholder='이름' value={userName ?? ""} onChange={onChangeName}/>
            <span style={{textAlign:'left', width:'100%', marginTop:'10px'}}>연락처</span>
            <InputBoxOnChange placeholder='연락처' value={userPhone} onChange={onChangePhone}/>
            <NextButton style={{marginTop:'20px'}} onClick={()=>handleSubmit(userName,userPhone)}>아이디 찾기</NextButton>
            </>
            }
            {currentPage === 'Correct' &&
            <>
            <span style={{textAlign:'center', width:'100%', marginBottom:'6px'}}>입력하신 정보와 일치하는 아이디를 찾았습니다.</span>
            <TextBox style={{marginBottom:'6px'}}>
            아이디 : {userId}<br/>
            가입일 : {formattedDate}
            </TextBox>
            <ButtonContainer>
              <NextButton onClick={()=>setField('tab','Login')}>로그인</NextButton>
              <FindPasswordButton onClick={()=>setField('tab','FindPw')}>비밀번호 찾기</FindPasswordButton>
            </ButtonContainer>
            </>}
            {currentPage === 'InCorrect' &&
            <>
            <ErrorOutlineIcon sx={{marginBottom:'14px'}}/>
            <span style={{textAlign:'center', width:'100%', marginBottom:'14px'}}>{errorText}</span>
            <ButtonContainer>
                <NextButton onClick={()=>setCurrentPage('FindingId')}>아이디 다시 찾기</NextButton>
            </ButtonContainer>
            </>}
        </LoginForm>
    </PageWrapper>
  )
}

export default AdFindIdBox